import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import getTransferReadingsValidation, {
  TransferReadingsValidationResponse,
} from "../http/getTransferReadingsValidation";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UseTransferReadingsValidationParams {
  siteId: string;
  esysUuid: string;
  month: string;
  counterpartyEsysUuid: string;
  enabled?: boolean;
}

const useTransferReadingsValidation = ({
  siteId,
  esysUuid,
  month,
  counterpartyEsysUuid,
  enabled = true,
}: UseTransferReadingsValidationParams) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchTransferReadingsValidation: UseQueryResult<
    TransferReadingsValidationResponse,
    unknown
  > = useQuery(
    ["site", siteId, "transfer-readings-validation", esysUuid, month, counterpartyEsysUuid],
    async () => {
      const authToken = await getAuthTokenBlocking(getToken, relogin);
      return getTransferReadingsValidation(authToken, siteId, esysUuid, month, counterpartyEsysUuid);
    },
    {
      enabled: enabled && !!siteId && !!esysUuid && !!month,
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    fetchTransferReadingsValidation,
  };
};

export default useTransferReadingsValidation;
